import React from "react";
import { useUpdateStyles } from "../hooks/useUpdateStyles";
import { useB2bProfile } from "../hooks/useB2bProfile";
import { Self } from "../../../shared/self";
export var Chat = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var isChatVisible = _a.isChatVisible, isProfi = _a.isProfi;
    var self = Self.useSelf().self;
    useB2bProfile((((_d = (_c = (_b = self === null || self === void 0 ? void 0 : self.profileInfo) === null || _b === void 0 ? void 0 : _b.employee) === null || _c === void 0 ? void 0 : _c.companyCorporateId) === null || _d === void 0 ? void 0 : _d.startsWith('QUW')) || ((_g = (_f = (_e = self === null || self === void 0 ? void 0 : self.profileInfo) === null || _e === void 0 ? void 0 : _e.employee) === null || _f === void 0 ? void 0 : _f.companyInternalId) === null || _g === void 0 ? void 0 : _g.startsWith('QY'))) && isProfi);
    useUpdateStyles(isChatVisible);
    return React.createElement(React.Fragment, null);
};
